import React, { useState } from 'react';
import xlentLogo from '../assets/tlogo.jpg';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    const result = await login(email, password);
    
    if (!result.success) {
      setError(result.message || 'Login failed');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex flex-col justify-center items-center relative overflow-hidden w-full px-4">
      {/* Login Card */}
      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-sm sm:max-w-md md:max-w-lg p-4 sm:p-6 md:p-8 rounded-2xl shadow-2xl border border-red-800/70 mx-auto bg-gray-800/80 backdrop-blur-md">
        {/* XLENT Logo */}
        <img src={xlentLogo} alt="TeenageFashion Logo" className="w-32 h-auto mb-6 rounded-lg shadow-lg object-contain" style={{ maxHeight: 90 }} />
        <h2 className="text-2xl sm:text-3xl font-semibold mb-6 text-center drop-shadow text-white tracking-wide">TeenageFashion</h2>
        {error && <div className="mb-2 bg-red-900/40 border border-red-700/60 text-red-200 text-sm text-center rounded px-3 py-2">{error}</div>}
        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-4">
          <input
            type="email"
            className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-red-600 border border-gray-600 text-base"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
          <input
            type="password"
            className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-red-600 border border-gray-600 text-base"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button
            type="submit"
            className="w-full mt-2 font-semibold py-3 rounded-full transition border border-red-700/60 shadow bg-red-800 text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 disabled:opacity-50 disabled:cursor-not-allowed text-base"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
} 